import React from 'react';
import { supportedLanguages, useTranslation } from '../../i18n';

export default function LanguageSelector() {
  const { language, changeLanguage, t } = useTranslation();

  return (
    <select
      aria-label={t('common.language')}
      value={language}
      onChange={(e) => changeLanguage(e.target.value)}
      className="bg-secondary text-secondary-foreground border rounded px-2 py-1"
    >
      {supportedLanguages.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
